// extracted by mini-css-extract-plugin
export default {"statusContainer":"services_statusContainer__nXaMt","btnNewContainer":"services_btnNewContainer__hGsSE"};